/** Espejo de backend/src/constants/featureFlags.ts — valores por defecto. */
export const FEATURE_FLAG_DEFAULTS: Record<string, boolean> = {
  whatsapp_habilitado: true,
  portal_clientes_habilitado: true,
  ordenes_sin_facturacion_habilitado: false,
  modulo_clinica_habilitado: false,
  preview_examenes_facturacion: true,
  formato_historial_versiones: true,
  permisos_formato_por_rol: true,
  formatos_modo_produccion: false,
  auditoria_impresion: true,
  validacion_bloques_en_vivo: true,
  formato_miniatura_pdf: false,
  formato_duplicar_entre_tipos: true,
  bloque_pie_legal: true,
  bloque_bilingue: false,
  marca_por_sucursal: false,
  qr_local_sin_externo: true,
  formato_exportar_importar: true,
  ocultar_canvas_deprecado: true,
  motor_pdf_unificado: true,
  motor_layout_obligatorio: true,
  ocultar_reportbro_bloques: true,
  usar_plantillas_word: false,
  firma_electronica_pdfa: false,
  plantillas_cliente_corporativo: false,
  impresion_directa_termica: false,
  portal_alineado_bloques: false,
  ia_analisis_orden_habilitado: false,
};
